import "./EarlyAccess.scss";

interface IEarlyAccessProps {}

function EarlyAccess(props: IEarlyAccessProps) {
  return <div className="early-access space-grotesk">Early access</div>;
}

export default EarlyAccess;
